import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCPF(value: string) {
  return value
    .replace(/\D/g, "") // Remove tudo o que não é dígito
    .replace(/(\d{3})(\d)/, "$1.$2") // Coloca ponto após o 3º dígito
    .replace(/(\d{3})(\d)/, "$1.$2") // Coloca ponto após o 6º dígito
    .replace(/(\d{3})(\d{1,2})/, "$1-$2") // Coloca traço após o 9º dígito
    .replace(/(-\d{2})\d+?$/, "$1"); // Impede digitar mais que 11 dígitos
}

export function validateCPF(cpf: string): boolean {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;

  const cpfArray = cpf.split("").map((el) => +el);
  const rest = (count: number) =>
    ((cpfArray
      .slice(0, count - 12)
      .reduce((soma, el, index) => soma + el * (count - index), 0) *
      10) %
      11) %
    10;

  return rest(10) === cpfArray[9] && rest(11) === cpfArray[10];
}